import { render, staticRenderFns } from "./question-form.vue?vue&type=template&id=56945ce9&scoped=true"
import script from "./question-form.vue?vue&type=script&lang=js"
export * from "./question-form.vue?vue&type=script&lang=js"
import style0 from "./question-form.vue?vue&type=style&index=0&id=56945ce9&prod&lang=less&scoped=true"
import style1 from "./question-form.vue?vue&type=style&index=1&id=56945ce9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56945ce9",
  null
  
)

export default component.exports